import { render, staticRenderFns } from "./BlockBanner.vue?vue&type=template&id=036510b2&scoped=true&"
import script from "./BlockBanner.vue?vue&type=script&lang=ts&"
export * from "./BlockBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBanner.vue?vue&type=style&index=0&id=036510b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036510b2",
  null
  
)

export default component.exports